module.exports = __webpack_public_path__ + "static/WB3-3bb542fa5ce1fb210376c56718209e53.jpg";